import { render, staticRenderFns } from "./schedule-an-appointment.vue?vue&type=template&id=5672dbc9&scoped=true"
import script from "./schedule-an-appointment.vue?vue&type=script&lang=js"
export * from "./schedule-an-appointment.vue?vue&type=script&lang=js"
import style0 from "./schedule-an-appointment.vue?vue&type=style&index=0&id=5672dbc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5672dbc9",
  null
  
)

export default component.exports